module.exports = __webpack_public_path__ + "img/bezginova.fbb7fea4.jpg";